<template> 
  <div>
    <BaseInputWithContextMenu
      :target-id="inputElementId"
      :is-read-only="isReadOnlyState"
      :value="Value"
      :control="$attrs.control"
      :additional-menu-items="additionalMenuItems"
      :enable-speech-features="true"
      :enable-system-options="true"
      @input="onInput"
      @control-changed="setChangedStatus"
      @context-menu-select="handleContextMenuSelect"
    >
    <b-form-input
      v-b-tooltip.hover :title="Hint"
      :type="Type"
      :maxlength="this.$attrs.control.controlMaxLenght"          
      :readonly="this.$attrs.control.isReadOnly || NoteIsVoid || this.$attrs.control.IsChartReview || this.isReadOnly"
      :min="Min"
      :max="Max"           
      :step="StepProp"
      :ref="RefProp"          
      :class="classValue" 
      v-bind:value="Value"
      v-on:blur="OnBlur($event)"
      v-on:change="OnChange"
      v-on:keyup.enter="$emit('keyup', $event)"
      :aria-describedby="this.$attrs.control.controlID"           
      v-on:keypress="$emit('keypress', $event)"
      v-on:input="onInput"
      v-on:focus="$emit('focus', $event.target.value)"
      v-bind:style="style"
      :id="inputElementId"
      ></b-form-input>
    </BaseInputWithContextMenu>
      
    <MdGetLastAnswers v-if="showGetLastAnswers"
      v-bind:ShowPopup="showGetLastAnswers"
      @getCancel="onCancelGetLastAnswers($event)"
      @getOK="onOKGetLastAnswers($event)"
      v-bind:ControlId="controlID"
      v-bind:PatientCode="PatientCode"
      v-bind:TransDate="TransDate"
    />
  </div>     
</template>

<script>
import { EventBus } from '../../event-bus.js';
import Vue from 'vue';
import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";

Vue.use(ContextMenuPlugin);
export default {
  name: 'MdEdit',
  mixins: [EventBus],
   props: {   
     StepProp:String,    
     isReadOnly:Boolean,
     Formatter:Function,
     Min:String,
     Max:String,
     Change:Function,
     RefProp:String,
     KeyEnter:Function,
     KeyPress:Function,
     FeedBackText:String,
     Name:String,
     value:[String, Number],
     TransDate: String,
     NoteId: String,
     id: [String, Number],
     PatientCode: String,
     IsCommonPart: Boolean,
     IsGroupContainer: Boolean
   },

   data(){
     return{
      classValue:"form-control cursor-context-menu",
      NoteIsVoid:false,
      style:{
        position:'absolute',
        top: this.$attrs.control.controlTop+'px',
        width:this.$attrs.control.controlWidth+'px',
        height:this.$attrs.control.controlHeight+'px',
        left:this.$attrs.control.controlLeft+'px',
        fontSize:'',
        fontWeight: '',
        fontFamily:'',
        color:'',
        backgroundColor:'',
        textDecorationLine:'',
        fontStyle:'',
        textTransform:'',
        borderColor: '',
        textAlign: 'left'
      },
      Hint: this.$attrs.control.controlHint,
      Type: 'text',
      isRequired: this.$attrs.control.isRequired,
      showGetLastAnswers: false,
      controlID:String(this.$attrs.control.controlID),
      //PatientCode: this.$route.params.id,
      Value: this.value,
      menuItems:[],
      targetId: "target-"+this.$attrs.HeaderId+"-"+this.$attrs.control.controlID,
      menuTargetId:"#target-"+this.$attrs.HeaderId+"-"+this.$attrs.control.controlID,
      idControl:this.id.toString()
     }
  },

  watch: {
     value: {
        immediate: true,
        handler: function(newModel) {
          this.Value = newModel;
        }
      }
  },
  computed: {
    inputElementId() {
       return this.$attrs.HeaderId + '-' + this.$attrs.control.controlID;
    },
     
    isReadOnlyState() {
       return this.$attrs.control.isReadOnly || this.NoteIsVoid || this.$attrs.control.IsChartReview || this.isReadOnly;
    },
     
    additionalMenuItems() {
       const items = [];
       if (!this.IsCommonPart) {
         items.push({ text: this.$t('ContextMenu.GetLast10'), id: "gettenlastans" });
       }
       return items;
    },
    enableSpeechFeatures() {
       // Example: Do not enable speech in numeric fields
       const controlDataType = this.$attrs.control.controlDataType;
       return controlDataType !== 'Integer' && controlDataType !== 'Money';
    },
    enableSystemOptions() {
        // Example: Do not enable speech in numeric fields
        const controlDataType = this.$attrs.control.controlDataType;
        return controlDataType !== 'Integer' && controlDataType !== 'Money';
    },
  },
  methods:{
      OnChange(value){
        //  this.$emit('change',evt.target.value)
        this.style.borderColor = !value && this.isRequired ? '#dc3545 !important': ''
        this.$emit('input',value)
      },

      OnBlur(evt){
        this.$emit('blur',evt.target.value)
        this.style.borderColor = evt.target.value.length == 0 && this.isRequired ? '#dc3545 !important': ''
      },

      setControlType() {
        let controlDataType = this.$attrs.control.controlDataType;
        if(controlDataType === 'Integer' || controlDataType === 'Money')
          this.Type = 'number'
        if(controlDataType === 'String')
          this.Type = 'text'
      },

      setControlCharCase() {
        let controlCharCase = this.$attrs.control.controlCharCase;
        if(controlCharCase === 'ecUpperCase')
          this.style.textTransform = 'uppercase'
        if(controlCharCase === 'ecLowerCase')
          this.style.textTransform = 'lowercase'
      },

      setAlignment() {
        if(this.$attrs.control.alignment) {
            if(this.$attrs.control.alignment === 'taCenter')
              this.style.textAlign = 'center'
            if(this.$attrs.control.alignment === 'taLeftJustify')
              this.style.textAlign = 'left'
            if(this.$attrs.control.alignment === 'taRightJustify')
              this.style.textAlign = 'right'
        }
      },

      InitializeVariables(){
        if(this.$attrs.control.controlColorForHtml)
            this.style.backgroundColor = this.$attrs.control.controlColorForHtml;
        else if(this.$attrs.control.isReadOnly || this.isReadOnly)
            this.style.backgroundColor = '#e9ecef !important'
        if(this.$attrs.control.controlFontForHtml){         
            this.controlFont = this.$attrs.control.controlFontForHtml.split(',');
            var size = parseInt(this.controlFont[1]) + 2;
            this.style.fontFamily = this.controlFont[0];
            this.style.fontSize = size+'px !important';
            this.style.color = this.controlFont[3];
            var Decorations = this.controlFont[2];
            this.style.fontWeight = Decorations.charAt(0) === '1'?'bold':'';
            this.style.fontStyle = Decorations.charAt(1) === '1'?'italic':'';
            this.style.textDecorationLine = Decorations.charAt(2) === '1'?'underline':'';
            this.style.textDecorationLine = Decorations.charAt(3) === '1'?this.style.textDecorationLine+ ' line-through':this.style.textDecorationLine;
        }
        this.setControlType();
        this.setControlCharCase();
        this.setAlignment();
      },

      showModalGetLastAnswers() {
        this.showGetLastAnswers = true
      },

      onCancelGetLastAnswers(){
        this.showGetLastAnswers = false
      },

      onInput(value) {
        this.Value = value;
        this.$emit('input',value)
        this.setChangedStatus()
      },

      ChangeValue(value) {
          this.onInput(value);
          this.OnChange(value);
      },

      onOKGetLastAnswers(value) {
        this.Value = value;
        this.$emit('input',value)
        this.setChangedStatus()
        this.showGetLastAnswers = false
      },

      handlerClick(evt){
        if(!this.$attrs.control.isReadOnly && !this.isReadOnly) {
          this.$refs.menu.open(evt)
        }
      },

      setValid(state){
          this.style.borderColor = state ? '#dc3545 !important': ''
      },
      // Managing custom context menu items
      handleContextMenuSelect(itemId) {
        if (itemId === 'gettenlastans') {
              this.showModalGetLastAnswers();
        }
      },

    setRequired(value) {
      this.isRequired = value;
      if (!value) {
        this.style.borderColor = '';
      } else if (this.Value === null || this.Value === undefined || this.Value.length === 0) {
        this.style.borderColor = '#dc3545 !important';
      }
    },

    onSelect: function(args ) {
       if(args.item.id === 'gettenlastans') {
         this.showModalGetLastAnswers()
       }
       if(args.item.id === 'recording') {
          EventBus.$emit('speechBarLabel', 'stop recording');
          this.$root.$refs.MdTextSpeech.toggleSpeechBar()//Utils.toggleSpeechBar();
          this.$root.$refs.MdTextSpeech.startSpeechToText(this.$attrs.control.controlID)
       }
       if(args.item.id === 'aiRecording') {
          EventBus.$emit('speechBarLabel', 'stop ai recording');
          this.$root.$refs.MdAIDictationSpeech.toggleSpeechBar()
          this.$root.$refs.MdAIDictationSpeech.SpeechToTextFromMic(this.$attrs.control.controlID)
       }
       if(args.item.id === 'speech') {
          EventBus.$emit('speechBarLabel', 'stop speech');
          this.$root.$refs.MdTextSpeech.toggleSpeechBar();
          this.$root.$refs.MdTextSpeech.startSpeech(this.Value)
       }
    },

    loadMenuItems() {
      this.menuItems = []
      if (!this.IsCommonPart) {
        this.menuItems.push({text: this.$t('Shared.GetLast10'), id: "gettenlastans"})
      }
      if (this.cmpLoaded) {
        if(this.$root.$refs.MdTextSpeech.isSpeechRecognitionSupported) {
          this.menuItems.push({text: this.$t('MdTextSpeech.record'), id: "recording"})
        }
        if(this.$root.$refs.MdAIDictationSpeech.isUsingPremiumDictation) {
          this.menuItems.push({text: this.$t('MdTextSpeech.aiRecord'), id: "aiRecording"})
        }
        this.menuItems.push({text: this.$t('MdTextSpeech.speech'), id: "speech"})
      }
    },

    setChangedStatus(){
      var changed = {
        "ControlId":this.$attrs.control.controlID,
        "Changed":true,
        "NoteId":this.NoteId
      }
      EventBus.$emit('onControlWasChanged', changed);
    },
    setValueS2T( sp ){
      let sp2t = ''
      if(this.value) {
        sp2t += Array.from (this.value + ""+sp).join("");
      } else {
        sp2t = Array.from (sp).join("");
      }
      this.Value = sp2t
      this.$emit('input', sp2t);
      this.setChangedStatus()
    },
    setValueContinuousS2T( sp ){
       this.Value = sp
       //this.$emit('input', sp);
       this.setChangedStatus()
       this.$nextTick(() => {
        this.scrollFieldToEnd();
      });
     },
      setValueAIS2T( sp ){
        this.Value = sp
        this.$emit('input', sp);
        this.setChangedStatus()
      },

      scrollFieldToEnd() {
        // Plain input / textarea (has a ref like RefProp or dictationTextarea)
        const nativeEl = this.$refs[this.RefProp]?.$el;
        if (nativeEl) {
          nativeEl.setSelectionRange(nativeEl.value.length, nativeEl.value.length);
          nativeEl.scrollLeft = nativeEl.scrollWidth;
          nativeEl.scrollTop = nativeEl.scrollHeight;
          return;
        }
      }
},

  created(){

    EventBus.$on("onSetReadOnly", function (e,id) {
       if(this.$attrs.HeaderId === id){
        this.NoteIsVoid = e;
      }
      }.bind(this));


    if(this.$attrs.NoteIsVoid){
      this.NoteIsVoid = this.$attrs.NoteIsVoid;
    }
    EventBus.$on("receivedS2T", function (event) {
      if( event.ControlId == this.$attrs.control.controlID) {
        this.setValueS2T( event.finalSentence )
      }
    }.bind(this))
    EventBus.$on("receivedContinuousS2T", function (event) {
      if( event.ControlId == this.$attrs.control.controlID) {
        this.setValueContinuousS2T( event.finalSentence )
      }
    }.bind(this))
    EventBus.$on("receivedAIS2T", function (event) {
      if( event.ControlId == this.$attrs.control.controlID) {
        this.setValueAIS2T( event.finalSentence )
      }
    }.bind(this))

  },
  mounted(){
    this.InitializeVariables();
    if (!this.IsCommonPart && this.IsGroupContainer && this.$attrs.control.isCommonControlNote) {
      this.Hint = this.$t('GroupNotesDashboard.ToCompletedInGroupFocus')
    }
  }
};

</script>

<style>
 @import '../../assets/css/Patients/Patient.css';
 .scroll{
	overflow: hidden !important;
}
</style>